export const ONETRUST_COOKIE_NAME = 'OptanonConsent';
/*
  The cookie consent keys will NEVER change. C002 will always be the Analytics cookie consent key for OneTrust
 */

export const ONETRUST_COOKIE_STRICTLY_NECESSARY_CONSENT_KEY = 'C0001';
export const ONETRUST_COOKIE_ANALYTICS_CONSENT_KEY = 'C0002';
export const ONETRUST_COOKIE_FUNCTIONAL_CONSENT_KEY = 'C0003';
export const ONETRUST_COOKIE_TARGETING_CONSENT_KEY = 'C0004';
export const ONETRUST_COOKIE_SOCIAL_MEDIA_CONSENT_KEY = 'C0005';

export const CONSENT_CHANGE_EVENT = 'OneTrustGroupsUpdated'